import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Image } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";
import Conceive from "~/images/logos/conceive.svg";

// Self-contained loader (not the shared ~/components LoadingPage) because this
// page renders outside Layout's Outlet, where LoadingPage's useIsPageLoading
// context is undefined and would throw. Mirrors PartnerRedirector's loading
// state. Shown while the carried partner trial auto-redeems before we navigate
// to set-password.
export const RedeemingLoader: FC = () => {
  const { t } = useTranslation();

  return (
    <FullBleedSection
      aria-live="polite"
      bgColor="bg-main"
      h="100vh"
      role="status"
    >
      <Image
        alt={t("onboarding.partnerLoading.loading")}
        maxW="20rem"
        src={Conceive}
        w="100%"
      />
    </FullBleedSection>
  );
};
